import logoColor from "@assets/images/gaz-logo-color.svg";
import logoWhite from "@assets/images/gaz-logo-white.svg";
import { Link } from "react-router-dom";

interface LogoProps {
  variant?: "default" | "white";
  className?: string;
  /** Overrides the rendered logo size. The lockup is ~2.8:1, so set height only. */
  imgClassName?: string;
}

export function Logo({
  // White is the default: every header/footer on this site sits on orange or
  // dark. Pass variant="default" only for the colour mark on a light background.
  variant = "white",
  className = "",
  imgClassName = "h-[48px] md:h-[60px]",
}: LogoProps) {
  const logo = variant === "white" ? logoWhite : logoColor;

  return (
    <Link to="/" className={`flex items-center flex-shrink-0 ${className}`}>
      <img
        src={logo}
        alt="GAZ"
        className={`w-auto shrink-0 ${imgClassName}`}
        loading="lazy"
      />
    </Link>
  );
}
